import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function useLookupCUI() {
  const [loading, setLoading] = useState(false);

  const lookupCUI = useCallback(async (cui) => {
    if (!cui || cui.length < 4) return null;
    const clean = cui.replace(/^RO/i, '').trim();
    if (!/^\d+$/.test(clean)) return null;

    setLoading(true);
    try {
      const response = await axios.get(`${API}/utils/lookup-cui/${clean}`);
      if (response.data?.found) {
        toast.success(`Firma gasita: ${response.data.name}`);
        return response.data;
      } else {
        toast.error('CUI negasit in baza de date ANAF');
        return null;
      }
    } catch {
      toast.error('Eroare la interogarea ANAF');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { lookupCUI, loading };
}
